import ExportCertificateRegistry from "../ExportCertificateRegistry";
import { hasPermission } from "../../permissions";

export default function ShipperExportCerts({ supplierId, lang, profile }) {
  return (
    <ExportCertificateRegistry
      lang={lang}
      lockSupplierId={supplierId}
      canCreate={hasPermission(profile, "create_export_certs")}
      canEdit={hasPermission(profile, "edit_export_certs")}
      canDelete={hasPermission(profile, "delete_export_certs")}
    />
  );
}
